export default [
  {
    key: 'id',
    type: 'id',
  },
  {
    key: 'name',
    label: 'Nama',
    type: 'profile',
    image: 'image_url',
  },
  {
    key: 'email',
    label: 'Email',
    type: 'email',
  },
  {
    key: 'phone',
    label: 'Nomor HP',
    type: 'whatsapp',
    prefix: '+',
  },
  {
    key: 'roles',
    label: 'Roles',
    type: 'badges',
    map: {
      admin: 'secondary',
      merchant: 'primary',
      'super-admin': 'warning',
      developer: 'danger',
    },
    limit: { index: 1, view: false },
    filter: {
      key: 'roles',
      type: 'select',
      label: 'Roles',
      options: [
        { value: 'admin', text: 'Admin' },
        { value: 'developer', text: 'Developer' },
        { value: 'merchant', text: 'Merchant' },
        { value: 'super-admin', text: 'Super Admin' },
      ],
    },
  },
  {
    key: 'last_login_at',
    label: 'Terakhir Login',
    type: 'datetime',
  },
  {
    key: 'created_at',
    label: 'Didaftarkan',
    type: 'datetime',
  },
  {
    key: 'updated_at',
    label: 'Diubah',
    type: 'datetime',
    visibility: ['view'],
  },
]
